package com.evoapps.evoshift.domain.privacy

/**
 * SH-255: "Hide in the roster for others": a person of a workplace whose shifts their colleagues
 * do not see, whatever the workplace's [com.evoapps.evoshift.domain.model.RosterVisibility]
 * (`workplaces/{id}/roster_privacy/{uid}`). The managers read the list, the person their own entry;
 * only the setRosterHidden function writes it (it also keeps the workplace's
 * [com.evoapps.evoshift.domain.model.WorkplaceSettings.rosterHasHiddenPeople]).
 */
interface RosterPrivacyRepository {
    /** Whether [userId] is hidden at [workplaceId] (read by themselves or the managers). */
    suspend fun isHidden(workplaceId: String, userId: String): Result<Boolean>

    /** Hides [userId] in [workplaceId]'s roster for the others, or shows them again (managers). */
    suspend fun setHidden(workplaceId: String, userId: String, hidden: Boolean): Result<Unit>
}

class GetHiddenInRosterUseCase(private val repository: RosterPrivacyRepository) {
    suspend operator fun invoke(workplaceId: String, userId: String): Result<Boolean> = repository.isHidden(workplaceId, userId)
}

class SetHiddenInRosterUseCase(private val repository: RosterPrivacyRepository) {
    suspend operator fun invoke(workplaceId: String, userId: String, hidden: Boolean): Result<Unit> =
        repository.setHidden(workplaceId, userId, hidden)
}
